import type { CellStatus } from '@eombor/contracts';

/**
 * Katak rangining **kaliti** — rangning o'zi emas.
 *
 * Qiymat `--color-fill-<key>` tokenidan o'qiladi (`scene-colors.ts`), shuning
 * uchun bu yerda hech qanday HEX yo'q va tema almashganda sahna o'z-o'zidan
 * to'g'ri rangga o'tadi.
 */
export const FILL_KEYS = ['empty', 'low', 'mid', 'high', 'blocked'] as const;

export type FillKey = (typeof FILL_KEYS)[number];

/**
 * Chegaralar: `<50%` — low, `50..84%` — mid, `>=85%` — high.
 *
 * Nima uchun 85 va 100 emas: skladchiga "to'ldi" degan signal joy TUGAMASDAN
 * oldin kerak. 100% da qizil bo'lsa, ogohlantirish kech keladi — javon
 * allaqachon to'lgan bo'ladi va yuk qabul qilinmaydi.
 *
 * `BLOCKED` foizdan qat'i nazar ustun turadi: bloklangan katakka mahsulot
 * qo'yilmaydi, uning qancha to'lgani ahamiyatsiz.
 */
export const fillKeyFor = (cell: { status: CellStatus | string; fillPercent: number }): FillKey => {
  if (cell.status === 'BLOCKED') return 'blocked';
  if (cell.fillPercent <= 0) return 'empty';
  if (cell.fillPercent >= 85) return 'high';
  if (cell.fillPercent >= 50) return 'mid';
  return 'low';
};
